import { React, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../../Context/LanguageContext';
import FetchModule from '../../../Share/Network/FetchModule.js';

import PartnerGymIndividualInfo from './PartnerGymIndividualInfo.js';
import PartnerGymHistoryView from './PartnerGymHistoryView.js';

export default function PartnerGymMemberDetailView(props) {
  const { memberId, division } = props;

  const history = useHistory();
  const { t } = useLanguage();

  const [memberData, setMemberData] = useState([
                                                {name: '',
                                                birthDay: '',
                                                gender: '',
                                                linkCoachId: '',
                                                phone: '',
                                                profile: 'None'}
                                                ]);
  const [memberShipData, setMemberShipData] = useState([]);
  const [totalMemberShips, setTotalMemberShips] = useState([]);
  const [lessonHistoryData, setLessonHistoryData] = useState([]);
  const [rendering, setRendering] = useState(false);

  // 회원 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/detail/' + memberId, 'GET');

        if (responseData.status === 200) {
          setMemberData(responseData.data);
        }
        else if (responseData.status === 201) alert(t('partnerGym.detail.alertMemberNotExist'));
        else if (responseData.status === 202) alert(t('partnerGym.detail.alertInvalidAccess'));
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [memberId, rendering])

  // 회원 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/detail/membership/' + memberId, 'GET');
        
        if (responseData.status === 200) {
          let memberShips = responseData.data.memberShipDetails;
          let memberShipHistories = responseData.data.memberShipHistoryDates.slice();

          memberShips.map((data) => ( data.historyData = [] ));

          // desc 진행 //
          memberShipHistories.sort(function (a, b) {
            return a.endDate > b.endDate ? -1 : a.endDate < b.endDate ? 1 : 0;
          })

          for (let i = 0; i < memberShips.length; i++) {
            for (let j = 0; j < memberShipHistories.length; j++) {
              if (memberShips[i].usageId === memberShipHistories[j].usageId) {
                memberShips[i].historyData.push(memberShipHistories[j]);
              }
            }
          }
          setMemberShipData(memberShips);
        }
        else if (responseData.status === 201) alert(t('partnerGym.detail.alertMemberNotExist'));
        else if (responseData.status === 202) alert(t('partnerGym.detail.alertInvalidAccess'));
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [memberId, rendering])

  // 회원권 수강내역 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/detail/reserve/' + memberId, 'GET');
        
        if (responseData.status === 200) {
          let finalLessonHistoryData = responseData.data.slice();

          for (let i = 0; i < finalLessonHistoryData.length; i++) {
            finalLessonHistoryData[i].createdDate = moment(finalLessonHistoryData[i].classDate.split('T')[0] + 'T' + finalLessonHistoryData[i].classTime.split('-')[0] + ':00').format('YYYY-MM-DDThh:mm:ss')
          }

          // desc 진행 //
          finalLessonHistoryData.sort(function (a, b) {
            return a.createdDate > b.createdDate ? -1 : a.createdDate < b.createdDate ? 1 : 0;
          })

          setLessonHistoryData(finalLessonHistoryData);
        }
        else if (responseData.status === 201) alert(t('partnerGym.detail.alertMemberNotExist'));
        else if (responseData.status === 202) alert(t('partnerGym.detail.alertInvalidAccess'));
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [memberId, rendering])

  // 회원권 수강 내역 정리 //
  useEffect(() => {
    if (memberShipData.length === 0 || lessonHistoryData.length === 0) {
      setTotalMemberShips(memberShipData);
      return;
    }

    let memberShips = memberShipData.slice();
    let finalLessonHistoryData = lessonHistoryData.slice();

    for (let i = 0; i < memberShips.length; i++) {
      let usageHistoryCount = 0;

      for (let j = 0; j < finalLessonHistoryData.length; j++) {
        if (memberShips[i].usageId === finalLessonHistoryData[j].usageId) usageHistoryCount += 1;
      }

      memberShips[i].courseTakeCount = usageHistoryCount;
    }

    setTotalMemberShips(memberShips);
  }, [memberShipData, lessonHistoryData])

  
  return (
    <TopLevelWrapper>
      <PartnerGymIndividualInfo memberData={memberData} rendering={() => setRendering(!rendering)} />
      <PartnerGymHistoryView
        memberShipData={totalMemberShips}
        division={division}
        lessonHistoryData={lessonHistoryData} />
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: 10px;

  transition: all 0.3s ease-in-out;
`;
